export const chartComponents = {
  MuiChartsWrapper: {
    styleOverrides: {
      root: {
        gap: '24px',
        flexWrap: 'wrap'
      }
    }
  },
  MuiChartsLegend: {
    styleOverrides: {
      series: {
        alignItems: 'flex-start'
      },
      root: {
        fontSize: '16px'
      }
    }
  },
  MuiChartsLabelMark: {
    styleOverrides: {
      circle: {
        height: '20px',
        width: '20px'
      }
    }
  }
}
